import {
	Box,
	Stack,
	Text,
} from '@chakra-ui/react'
import "/node_modules/flag-icons/css/flag-icons.min.css"

export default function StationDisplayElement({station}) {
    return (
        <Box
            m={1}
        >
            <Stack
                direction='row'
                align='stretch'
            >
                <Stack>
                    <Text
                        as='b'
                        fontSize='lg'
                    >
                        {station.name}
                    </Text>
                    <Text
                        // as='i' 
                        fontSize='sm'
                        color='gray.500'
                    >
                        {station.nameSecondary}
                    </Text>
                </Stack>

                {/* Only to align the flag to the left */}
                <Box
                    flexGrow="1"
                />

                {/* Hide RU flag */}
                { station.country.code !== 'RU' ?
                    <Box
                        className={`fi fi-${(station.country.code).toLowerCase()}`}
                    />
                    :
                    <Box>
                        <Text>RU</Text>
                    </Box>
                }
            </Stack>
        </Box>
    )
}